const rxHtmlTitle = /<title>(.*?)<\/title>/

/**
 * A quick way to get document fields without parsing
 * @param docType
 * @param document
 * @param field
 * @param defaultValue
 * @returns {String}
 */
function getDocumentField(docType, document, field, defaultValue) {
  let m
  switch (docType) {
    case 'html':
      if (field === 'title') {
        m = rxHtmlTitle.exec(document);
        if (m) {
          return m[1].trim()
        }
      }
      return defaultValue
    case 'quickchords':
    case 'text':
    case 'markdown':
    default:
      const rxField = `^:${field}[ \t]*(.*)`
      m = new RegExp(rxField, 'm').exec(document)
      if (m) {
        return m[1].trim()
      } else {
        return defaultValue
      }
  }
}

export {getDocumentField}